import React, { useEffect, useState } from "react";
import API from "../lib/TimeEditAPI";
import ArrayInput from "./ArrayInput";
import _ from "underscore";

const DEFAULT_SIZE = 5;

type TPeriod = { id: number; name: string };

type TPeriodTypeInputProps = {
    defaultValue?: number;
    onUpdate: (period?: TPeriod) => void;
    limit?: number;
    defaultSize?: number;
    /** Passed by Settings but unused here; kept so the prop is accounted for. */
    size?: number;
};

const PeriodTypeInput = (props: TPeriodTypeInputProps) => {
    const [periods, setPeriods] = useState<TPeriod[]>([]);

    useEffect(() => {
        API.findPeriods((found) => {
            setPeriods([{ id: 0, name: "-" }].concat(found));
        });
    }, []);

    const onUpdate = (selectedId) => {
        props.onUpdate(_.find(periods, (period) => period.id === selectedId));
    };

    const options = periods.map((period) => ({
        value: period.id,
        label: period.name,
        selected: period.id === props.defaultValue,
    }));
    return (
        <ArrayInput
            defaultValue={options}
            disabled={periods.length === 0}
            onUpdate={onUpdate}
            limit={props.limit || 0}
            defaultSize={props.defaultSize || DEFAULT_SIZE}
        />
    );
};

export default PeriodTypeInput;
